/* ============================================
   SnooozeCo — FAQ JS (FLIP Animation — No Snapping Ever)
============================================ */

document.addEventListener("DOMContentLoaded", initFAQ);
document.addEventListener("shopify:section:load", initFAQ);

function initFAQ() {
  const items = document.querySelectorAll(".faq-item");
  if (!items.length) return;

  items.forEach(item => {
    const summary = item.querySelector("summary");
    const wrapper = item.querySelector(".faq-answer-wrapper");
    if (!summary || !wrapper) return;

    // BLOCK NATIVE DETAILS TOGGLE
    summary.addEventListener("click", e => {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = item.hasAttribute("open");

      if (isOpen) {
        closeItem(item, wrapper);
      } else {
        // close others
        items.forEach(other => {
          if (other !== item && other.hasAttribute("open")) {
            closeItem(other, other.querySelector(".faq-answer-wrapper"));
          }
        });
        openItem(item, wrapper);
      }
    });
  });
}

function openItem(item, wrapper) {
  item.setAttribute("open","");

  // FLIP: First → Last
  const startHeight = 0;
  const endHeight = wrapper.scrollHeight;

  wrapper.style.height = startHeight + "px";

  // Wait one frame so the browser registers starting height
  requestAnimationFrame(() => {
    wrapper.style.height = endHeight + "px";
  });

  wrapper.addEventListener("transitionend", function finish() {
    if (item.hasAttribute("open")) {
      wrapper.style.height = "auto"; // natural height
    }
    wrapper.removeEventListener("transitionend", finish);
  });
}

function closeItem(item, wrapper) {
  // FLIP: Auto → px
  wrapper.style.height = wrapper.scrollHeight + "px";

  // Force reflow
  wrapper.getBoundingClientRect();

  // Now animate to 0
  requestAnimationFrame(() => {
    wrapper.style.height = "0px";
  });

  wrapper.addEventListener("transitionend", function finish(e) {
    if (e.propertyName !== "height") return;

    item.removeAttribute("open");
    wrapper.removeEventListener("transitionend", finish);
  });
}
